import { render, staticRenderFns } from "./productSelection.vue?vue&type=template&id=68db553e&scoped=true&"
import script from "./productSelection.vue?vue&type=script&lang=js&"
export * from "./productSelection.vue?vue&type=script&lang=js&"
import style0 from "./productSelection.vue?vue&type=style&index=0&id=68db553e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68db553e",
  null
  
)

export default component.exports